import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=76ff8fe9"
import script from "./InputBox.vue?vue&type=script&lang=js"
export * from "./InputBox.vue?vue&type=script&lang=js"
import style0 from "./InputBox.vue?vue&type=style&index=0&id=76ff8fe9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports